import { Vocab } from '../hooks/useVocab'
import DefinitionText from './DefinitionText'
import Modal, { ModalProps } from './Modal'
import Button from './Button'

type VocabSheetProps = {
  vocab: Vocab[]
  onRemove: (v: Vocab) => void
} & ModalProps

const VocabSheet = ({
  vocab,
  onRemove,
  ...props
}: VocabSheetProps) => (
  <Modal {...props}>
    {(!vocab || vocab.length === 0) && (
      <span className="text-center italic">
        No vocab words added
      </span>
    )}
    {vocab.map((vocab) => (
      <div
        className="relative max-h-32 overflow-y-auto rounded-lg p-4 shadow-inner ring-2 ring-slate-900/5 "
        key={vocab.word.clean}
      >
        <Button
          onClick={() => onRemove(vocab)}
          className="absolute top-2 right-2 bg-red-400 px-4 text-white"
        >
          Remove
        </Button>
        <div className="max-h-32">
          <DefinitionText vocab={vocab} />
          {!!(vocab?.numEncounters || 0) && (
            <span className="py-4 text-xs">
              Seen {vocab?.numEncounters} time
              {vocab!.numEncounters! > 1 && 's'}
            </span>
          )}
        </div>
      </div>
    ))}
  </Modal>
)

export default VocabSheet
